import { render, staticRenderFns } from "./HistoryPoint.vue?vue&type=template&id=61e51606"
import script from "./HistoryPoint.vue?vue&type=script&lang=js"
export * from "./HistoryPoint.vue?vue&type=script&lang=js"
import style0 from "./HistoryPoint.vue?vue&type=style&index=0&id=61e51606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports